/* Shopify 2026 standard storefront event bridge. These are local, bubbling DOM
   interoperability events for apps/agents—not Web Pixel emissions and not a
   replacement for the consent-gated jp:track analytics boundary. */
import * as StandardEvents from 'https://cdn.shopify.com/storefront/standard-events.js';

window.Shopify = window.Shopify || {};
window.Shopify.StandardEvents = StandardEvents;

if (!customElements.get('s-view-event')) {
  customElements.define('s-view-event', StandardEvents.createViewEventElement());
}

const dispatchPageView = () => {
  if (window.__jpStandardPageView) return;
  window.__jpStandardPageView = true;
  document.dispatchEvent(new StandardEvents.PageViewEvent({
    page: {
      template: document.body.dataset.template || '',
      title: document.title,
      url: window.location.href,
    },
  }));
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dispatchPageView, { once: true });
else dispatchPageView();
